export function addDefaultRows<T, TEmpty>(
  array: (T | TEmpty)[],
  generateItem: () => TEmpty,
  defaultAmount: number,
): (T | TEmpty)[] {
  const arrayDefaultRows = Array.from({ length: defaultAmount - (array || []).length }, () => generateItem());
  return (array || []).concat(arrayDefaultRows);
}
